import { Permissions } from "configs";

import { ModelName } from "./types";

export const MappingPermission: Record<ModelName, keyof typeof Permissions> = {
  country: "CountryShort",
  province: "ProvinceShort",
  district: "DistrictShort",
  ward: "WardShort",
  deduction: "DeductionShort",
  allowance: "AllowanceShort",
  earning: "EarningShort",
  compensation: "CompensationShort",
  leavePolicy: "LeavePolicyShort",
  workLevel: "WorkLevelShort",
  department: "DepartmentShort",
  branch: "BranchShort",
  title: "TitleShort",
  contractType: "ContractTypeShort",
  employee: "EmployeeShort",
  "payroll-template": "PayrollTemplateShort",
  "payroll-template-pic": "PayrollTemplatePicShort",
  timezone: "TimezoneShort",
  workShift: "WorkShiftShort",
  leaveType: "LeaveTypeShort",
  bank: "BankShort",
  approvalWorkflow: "ApprovalWorkflowShort",
  ethnicity: "EthnicityShort",
  role: "RoleShort",
  benefitsInKind: "BenefitsInKindShort",
  payrollCycle: "PayrollCycleShort",
  machine: "MachineShort",
  "machine-group": "MachineGroupShort",
  product: "ProductShort",
  "reason-stop-machine": "ReasonStopMachineShort",
  "productivity-template": "ProductivityTemplateShort",
  "productivity-template-pic": "ProductivityTemplateMeShort",
  "productivity-workShift": "ProductivityWorkShiftShort",
};
